/**
 * File: src/components/footer.js
 * Mô tả: Component Footer chân trang hiển thị bản quyền, liên kết nhanh, Privacy Policy và thông tin liên hệ.
 * Liên quan: src/i18n/i18n-service.js, src/data/site-config.js
 */

import { createElement } from '../utils/dom.js';
import { siteConfig } from '../data/site-config.js';
import { t, onLanguageChange } from '../i18n/i18n-service.js';

export const renderFooter = () => {
  const footer = createElement('footer', { className: 'site-footer' });

  const renderContent = () => {
    footer.innerHTML = `
      <div class="container">
        <div class="footer-grid">
          <div>
            <div class="brand-logo" style="margin-bottom: 1rem;">
              <img src="/assets/images/brand/logo.webp" alt="SNT Games Logo" class="logo-icon" style="width: 32px; height: 32px;" />
              <span>${siteConfig.name}</span>
            </div>
            <p style="color: var(--color-text-muted); font-size: 0.9rem; max-width: 320px;">
              ${t('footer.desc')}
            </p>
          </div>
          <div>
            <h4 style="margin-bottom: 1rem; font-size: 1rem;">${t('footer.quickLinks')}</h4>
            <ul style="display: flex; flex-direction: column; gap: 0.5rem; font-size: 0.9rem; color: var(--color-text-muted);">
              <li><a href="/" style="color: inherit;">${t('nav.home')}</a></li>
              <li><a href="/#games" style="color: inherit;">${t('nav.games')}</a></li>
              <li><a href="/beatglide/privacy" style="color: var(--color-accent);">🔒 Privacy Policy (BeatGlide)</a></li>
              <li><a href="/ant-clash/privacy" style="color: var(--color-accent); font-weight: 600;">🔒 Privacy Policy (Ant Clash)</a></li>
            </ul>
          </div>
          <div>
            <h4 style="margin-bottom: 1rem; font-size: 1rem;">${t('footer.contact')}</h4>
            <p style="color: var(--color-text-muted); font-size: 0.9rem;">Email: <a class="company-email" href="mailto:${siteConfig.contact.email}">${siteConfig.contact.email}</a></p>
            <p style="color: var(--color-text-muted); font-size: 0.9rem;">${siteConfig.contact.address}</p>
            <div style="display: flex; flex-wrap: wrap; gap: 1rem; margin-top: 1rem;">
              ${siteConfig.socialLinks.filter((link) => link.verified === true && /^https:\/\//.test(link.url)).map((link) => `<a class="company-email" href="${link.url}" target="_blank" rel="noopener noreferrer">${link.name}</a>`).join('')}
            </div>
          </div>
        </div>
        <div class="footer-bottom" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 1rem;">
          <div>© ${new Date().getFullYear()} ${siteConfig.name}. ${t('footer.rights')}</div>
          <div>
            <a href="/ant-clash/privacy" style="color: var(--color-text-dim); font-size: 0.85rem;">Ant Clash Privacy Policy</a>
          </div>
        </div>
      </div>
    `;
  };

  renderContent();
  onLanguageChange(() => renderContent());

  return footer;
};
